import text from '../lib/dictionary.json';
import { post } from './http';

export const validateFormData = (body, lang, page, setAlertState) => {
    if (typeof body === 'string') {
        const fieldName = text[lang][`add-${page}-${body}-name`]?.replace('*', '')?.trim() || '';
        setAlertState({
            open: true,
            message: `${text[lang]['mandatory-fields']} "${fieldName}"`,
            type: 'error'
        });
        return false;
    } else if (body.overlap) {
        const fieldName = text[lang][`add-${page}-${body.key}-name`]?.replace('*', '')?.trim() || '';
        setAlertState({
            open: true,
            message: `${text[lang]['overlap-field']} "${fieldName}"`,
            type: 'error'
        });
        return false;

    } else if (body.number) {
        const fieldName = text[lang][`add-${page}-${body.key}-name`]?.replace('*', '')?.trim() || '';
        setAlertState({
            open: true,
            message: `${text[lang]['number-field']} "${fieldName}"`,
            type: 'error'
        });
        return false;

    }

    return true;
};



export const uploadAttachments = async (selectedFiles) => {
    
    if (!selectedFiles || selectedFiles.length === 0) return null;

    const fileFormData = new FormData();
    selectedFiles.forEach(file => fileFormData.append('files', file));

    const uploadRes = await post(`/attachments/upload-multi`, fileFormData);

    return uploadRes.data;

};


export const checkAuthAccess = ({
  userPermissions = {},
  activeServices = [],
  serviceKey,
  permissionKey,
  action // 'read' | 'write' | 'readWrite'
}) => {
  const isServiceEnabled = serviceKey
    ? Boolean(activeServices?.includes(serviceKey))
    : true;

  const hasPermission = (() => {
    if (!permissionKey) return true;

    const modulePermission = userPermissions[permissionKey];
    if (!modulePermission) return false;

    if (action === 'read') {
      return Boolean(modulePermission.read);
    }

    if (action === 'write') {
      return Boolean(modulePermission.write);
    }

    if (action === 'readWrite') {
      return Boolean(modulePermission.read && modulePermission.write);
    }

    return Boolean(modulePermission.read || modulePermission.write);
  })();

  return {
    isServiceEnabled,
    hasPermission,
    canAccess: isServiceEnabled && hasPermission
  };
};